import api from "!../padloc/packages/pwa/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../padloc/packages/pwa/node_modules/css-loader/dist/cjs.js!./theme.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};